<template>
  <div class="wrapper">
    <flex-column>
      <flex-header>
        <div class="header">
          <flex-row gap center>
            <flex-cell>
              <h3>Select {{ definition.title }} fields to add</h3>
            </flex-cell>
            <flex-cell shrink>
              <ux-button @click="dismiss">Cancel</ux-button>
            </flex-cell>
            <flex-cell shrink>
              <ux-button color="primary" @click="done">Done</ux-button>
            </flex-cell>
          </flex-row>
        </div>
      </flex-header>
      <flex-body class="body-area">
        <a
          class="field-item"
          :class="{
            selected: isSelected(field),
            parented: isParentSelected(field),
          }"
          :style="field.style"
          @click="toggle(field)"
          v-for="field in fields"
        >
          <flex-row gap center>
            <flex-cell shrink>
              <ux-checkbox
                :value="isSelected(field) || isParentSelected(field)"
              />
            </flex-cell>
            <flex-cell>
              <strong>{{ field.selectTitle }}</strong>
            </flex-cell>
            <flex-cell shrink class="font-muted">
              <div class="font-sm font-muted">{{ field.path }}</div>
            </flex-cell>
          </flex-row>
        </a>
      </flex-body>
    </flex-column>
  </div>
</template>
<script>
import ModalMixin from "../../../modal/ModalMixin.js";

export default {
  data() {
    return {
      selection: {},
    };
  },
  mixins: [ModalMixin],
  computed: {
    keys() {
      const keys = [];
      for (var key in this.selection) {
        if (!!this.selection[key]) {
          keys.push(key);
        }
      }

      return keys;
    },
    definition() {
      return this.options.definition;
    },
    fields() {
      const self = this;

      if (!self.definition) {
        return [];
      }

      let fields = (self.definition.fields || [])
        .filter(function (f) {
          if (f.readOnly) {
            return false;
          }

          return true;
        })
        .map(function (field) {
          switch (field.key) {
            case "data":
              field.title = "Custom Fields";
              break;
          }
          return field;
        });

      fields = self.$sdk.utils.mapFields(fields, {
        includeLayout: true,
        original: true,
      });

      fields = fields
        .map(function (field) {
          if (field.path.startsWith("meta")) {
            return;
          }

          field.selectTitle = field.titles.filter(Boolean).join(" › ");

          switch (field.path) {
            case "dob":
              return [
                {
                  ...field,
                  selectTitle: "Date of birth › Date Picker",
                  title: "Date of Birth",
                  key: "dob",
                  path: "dob:date",
                  type: "date",
                  widget: "datepicker",
                  dateOnly: true,
                  style: {
                    marginLeft: `${(field.trail.length * 1 - 1) * 2}em`,
                  },
                },
                {
                  ...field,
                  selectTitle: "Date of birth › Date Fields",
                  title: "Date of Birth",
                  key: "dob",
                  path: "dob:object",
                  type: "object",
                  widget: "dateobject",
                  dateOnly: true,
                  style: {
                    marginLeft: `${(field.trail.length * 1 - 1) * 2}em`,
                  },
                },
                // {
                //   ...field,
                //   selectTitle: "Date of birth › Day+Month+Year",
                //   key: "dob",
                //   path: "dob:fields",
                //   style: {
                //     marginLeft: `${(field.trail.length * 1 - 1) * 2}em`,
                //   },
                // },
              ];

              break;
            case "dobDay":
              return;
              field.selectTitle = "Date of birth › Day";
              break;
            case "dobMonth":
              return;
              field.selectTitle = "Date of birth › Month";
              break;
            case "dobYear":
              return;
              field.selectTitle = "Date of birth › Year";
              break;
            case "data":
              field.selectTitle = "All Custom Fields";
              break;
          }

          field.style = {
            marginLeft: `${(field.trail.length * 1 - 1) * 2}em`,
          };
          return field;
        })
        .flat()
        .filter(Boolean)
        .sort(function (a, b) {
          if (a.selectTitle < b.selectTitle) {
            return -1;
          }

          if (a.selectTitle > b.selectTitle) {
            return 1;
          }

          return 0;
        })
        .sort(function (a, b) {
          // Keep 'data' and its children at the bottom
          const aIsData = a.path === "data" || a.path.startsWith("data.");
          const bIsData = b.path === "data" || b.path.startsWith("data.");

          if (aIsData && !bIsData) return 1;
          if (bIsData && !aIsData) return -1;

          if (a.path < b.path) {
            return -1;
          }

          if (a.path > b.path) {
            return 1;
          }

          return 0;
        });

      return fields;
    },
  },
  methods: {
    isSelected(field) {
      return this.selection[field.path];
    },
    isParentSelected(field) {
      return this.keys.some(function (key) {
        return field.path != key && field.path.startsWith(key);
      });
    },
    done() {
      const selection = this.selection;
      const fieldSource = JSON.parse(JSON.stringify(this.fields));
      const matched = {};
      const plucked = [];

      function pluckFields(parent, fields) {
        fields.forEach(function (field) {
          // If it's an exact match, add the field and continue on
          if (selection[field.path] && !matched[field.path]) {
            matched[field.path] = true;
            parent.push(field);
            return;
          }

          // If the field has child fields
          const childFields = field.fields || [];
          if (childFields.length) {
            // Wipe the fields and start with a new array
            field.fields = [];

            // Loop through these fields now
            pluckFields(field.fields, childFields);

            if (field.fields.length) {
              parent.push(field);
            }
          }
        });
      }

      pluckFields(plucked, fieldSource);

      this.close(plucked);
    },
    toggle(field) {
      this.selection[field.path] = !this.selection[field.path];
      console.log(field);
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  background: var(--bg1, #fff);
  max-width: 80vw;
  display: flex;
  overflow: hidden;
  border-radius: 0.3em;
}

.header {
  padding: 1em;
  border-bottom: 1px solid rgba(#000, 0.1);

  h3 {
    margin: 0;
  }
}

.body-area {
  background: var(--bg3, #eee);
  padding: 1em;
  font-size: 0.9em;
}

.field-item {
  background: var(--bg1, #fff);
  display: block;
  margin: 0 0 0.2em;
  padding: 0.5em 1em;
  border: 1px solid rgba(#000, 0.1);
  cursor: pointer;
  border-radius: 0.3em;

  &:hover {
    border: 1px solid rgba(#000, 0.2);
  }

  &.selected {
    border-color: var(--primary);
  }

  &.parented {
    border-color: var(--primary);
    opacity: 0.5;
  }
}
</style>
